const Seo = resolve => {
    require.ensure(['../views/apps/seo/Seo'], () => {
        resolve(require('../views/apps/seo/Seo'))
    })
};
const SeoDetay = resolve => {
    require.ensure(['../views/apps/seo/SeoDetay'], () => {
        resolve(require('../views/apps/seo/SeoDetay'))
    })
};

import Vue from 'vue'
Vue.component('SeoDetay', SeoDetay);
import layouts from '../layout'

export default {
    path: '/seo',
    name: 'seo',
    component: Seo,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'seodetay',
            component: SeoDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
